<template>
	<v-container class="d-flex justify-center text-center">
		<v-card flat max-width="448">
			<v-avatar size="64px">
				<img :src="logo">
			</v-avatar>

			<v-card-text>
				<v-form ref="form">
					<v-row no-gutters>
						<v-col cols="12">
							<div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
								E-mail
							</div>
							<v-text-field 
								prepend-inner-icon="mdi-email"
								type="text"
								v-model="item.username"
								:rules="[rules.required, rules.email]"
								outlined
								required    
								@keyup.ctrl.90="OnDefault"
								@keyup.enter="OnOK"
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
								{{ $vuetify.lang.t('$vuetify.password') | capitalize }}
								<v-btn text 
									tile
									x-small
									:to="{name: 'passwordrecovery'}">
									{{ $vuetify.lang.t('$vuetify.passwordforgot') | capitalize }}
								</v-btn>
							</div>
							<v-text-field 
								prepend-inner-icon="mdi-lock"
								:append-icon="visiblePassword ? 'mdi-eye-off' : 'mdi-eye'"
								:type="visiblePassword ? 'text' : 'password'"
								v-model="item.password"
								hint="At least 8 characters"
								min="8"
								outlined
								required
								:rules="[rules.required]"
								@keyup.ctrl.90="OnDefault"
								@keyup.enter="OnOK"
								@click:append="visiblePassword = !visiblePassword"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>

				<z-alert ref="alert"></z-alert>
			</v-card-text>

			<v-card-actions>
				<v-btn 
					large block
					:loading="loading"
					color="success"
					dark
					@click.native="OnOk"
				>
					{{ $vuetify.lang.t('$vuetify.login') }}	
				</v-btn>
			</v-card-actions>

			<!-- <v-card-text>
				<v-btn text tile x-small :to="{name: 'connection'}">
					{{ $vuetify.lang.t('$vuetify.orderconnection') | capitalize }}
				</v-btn>
			</v-card-text> -->
		</v-card>
	</v-container>
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
import { mapGetters, mapActions } from 'vuex'
import zAlert from '@/views/components/alert'

export default {
	components: {
		VueRecaptcha, zAlert
	},
	data: () => ({
		//title: 'authorization',
		title: 'signin',
		icon: 'mdi-account-key',
		loading: false,

		visiblePassword: false,

		logo: require('../assets/logo.svg'),

		rules: {
			required: (value) => !!value || "Обов'язкове для заповнення.",
			email: (value) => {
				const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				return pattern.test(value) || 'Некоректний e-mail.'
			},
			name: (value) => {
				const pattern = /^([a-zA-Zа-яА-ЯЇї'\- ]+)/
				return (value && value.length <= 100 && pattern.test(value)) || 'Дані некоректні '
			},
			phone: (value) => {
				const pattern = /^\+?3?8?(0\d{9})$/
				return (value === null || value.length == 0 || pattern.test(value)) || 'Номер телефону не вірний (+380961112233)'
			},
		},

		item: {
			username: null,
			password: null,
		},
	}),
	
	/* computed: {
		...mapGetters([ 'holder']),
	}, */

	methods: {
		...mapActions([ 'setHolder', 'showMessage' ]),
		...mapActions('app',[
			'Authorization'
		]),

		...mapActions('recaptcha',{
			recaptchaExpired: 'Expired',
			recaptchaValidate: 'Validate',
			recaptchaError: 'Error',
		}),

		OnDefault () {
			//ctrl+z
			this.item.username     = ""
			this.item.password     = ""
		},

		OnOk() {
			this.$refs.alert.Close();

			if (this.$refs.form.validate()) {
				//Ідентифікація користувача
				this.UserIdentification()
			}
		},

		/**
		 * Ідентифікація користувача
		 */
		UserIdentification () {
			var that = this;
			this.loading = true;

			axios.post('/login', this.item).then(response => {
				//console.log('Login','OnOk', 'response', response)

				let token = response.data.token
				localStorage.setItem('token', token)
				axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

				//Авторизація
				that.UserAuthorization()
			}, error => {
				//if(data.hasOwnProperty('error')) data.error(error.response);
				//console.log(context.getters.name,'Login: error', 'error', error)
			}).finally(() => (this.loading = false));
		},

		/**
		 * Авторизація користувача
		 */
		UserAuthorization () {
			this.loading = true
			var that = this
			axios.get('/authorization').then(response => {
				//console.log('app.Login', 'Authorization', 'data', response.data)

				//that.Authorization(response.data);
				that.setHolder(response.data);
				that.$router.push('/');
			}, error => {
				//console.log('App','created', 'error', error)
				//that.$router.push('/login')
			}).finally(() => (this.loading = false));
		},
	},
}
</script>